import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInformationIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 8a1 1 0 1 1-2 0v-5a1 1 0 1 1 2 0zm-1 6c5.53 0 10-4.5 10-10a10 10 0 1 0-10 10m0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgInformationIcon;